import type { Fallacy } from "./types";
import { createStory } from "./types";

export const screenshotProof: Fallacy = {
    id: "screenshot-proof",
    name: "Screenshot as Proof",
    emoji: "📸",
    category: "Jebakan Digital",
    description:
      "Menjadikan screenshot sebagai **bukti tak terbantahkan**, padahal screenshot sangat **mudah diedit dan dipalsukan**.",
    tldr: "Screenshot bisa diedit dalam 30 detik — jangan jadikan bukti mutlak.",
    detail:
      "Screenshot WhatsApp, tweet, DM Instagram, transaksi bank — semuanya dijadikan senjata untuk membuktikan klaim di media sosial. Masalahnya? **Screenshot adalah salah satu hal yang paling mudah dipalsukan**.\n\nDengan aplikasi editing atau fitur **Inspect Element** di browser, siapa pun bisa membuat screenshot palsu dalam hitungan detik — tanpa keahlian khusus.\n\nKenapa ini berbahaya? Karena screenshot memberikan **ilusi otentisitas**. Terlihat seperti 'bukti langsung' padahal bisa saja hasil manipulasi. Banyak kasus cyberbullying dan fitnah bermula dari screenshot palsu.\n\nCara melawan: Tanyakan — apakah ada **sumber asli yang bisa diverifikasi**? Apakah ada link ke post aslinya? Screenshot tanpa verifikasi independen bukan bukti yang valid.",
    story: createStory("Screenshot as Proof", "📸", {
      hook: {
        title: "\"Ini screenshot-nya, udah jelas!\"",
        body: "Padahal bikin screenshot palsu cuma butuh 30 detik dan Inspect Element.",
      },
      convo: {
        claim: "Aku ada buktinya kok, **ini screenshot chat WA-nya udah jelas**, hitam di atas putih. Gak perlu verifikasi lagi.",
        response: "Bikin screenshot palsu cuma butuh 30 detik. **Screenshot bukan bukti, itu gambar.**",
      },
      reveal: {
        body: "Screenshot kasih **ilusi otentisitas** — keliatan kayak bukti langsung, padahal bisa hasil **manipulasi yang gampang banget** dibuat.",
      },
      insight: {
        title: "Kenapa berbahaya?",
        body: "Siapa pun bisa bikin screenshot palsu **tanpa keahlian khusus** — cukup Inspect Element atau app editing. Banyak kasus fitnah bermula dari sini.",
      },
      engagement: {
        title: "Pernah hampir percaya screenshot yang ternyata palsu? 📸",
        body: "Chat WA, tweet, atau bukti transfer? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["hasty-generalization", "framing-effect", "cherry-picking"],
  };
